import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import ParticlesNav from './ParticlesNav';

export default function Nav() {
    var date = new Date(),
        hour = date.getHours();

    const [isOpen, setIsOpen] = useState(false)
    const [classToggle, setclass] = useState("toggler")
    const [menuTog, setmenuTog] = useState('-150vh')
    const [menuRTog, setmenuRTog] = useState('150vh')
    const [greeting, setgreeting] = useState(" Night!")
    const [myName, setmyName] = useState(0)
    const [color, setcolor] = useState('white')
    const list = {
        initial: {
            opacity: 0,
            x: '150vw',
            // y: '-150px',
        },
        animate: {
            opacity: 1,
            x: menuTog,
            // y: menuTog,
        }
    }
    const rlist = {
        initial: {
            opacity: 0,
            x: '-150vw',
            // y: '-150px',
        },
        animate: {
            opacity: 1,
            x: menuRTog,
            // y: menuTog,
        }
    }

    const navTextColor = (scrollT, vh) => {
        if (window.location.href.search('about') !== -1 && scrollT > vh - 10) {
            setcolor('black')
        } else {
            setcolor('white')
        }
    }

    const toggle = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            setclass("toggler change")
            setmenuTog('0')
            setmenuRTog('0')
            navTextColor()
        } else {
            setclass("toggler")
            setmenuTog('-150vh')
            setmenuRTog('150vh')
            if (window.location.href.search('about') !== -1 && window.scrollY > window.innerHeight) {
                setcolor('black')
            }
        }
    }

    const getGreeting = () => {
        if (hour > 4 && hour < 12) {
            setgreeting(" Morning!")
        } else if (hour >= 12 && hour < 17) {
            setgreeting(" Afternoon!")
        } else if (hour >= 17 && hour < 20) {
            setgreeting(" Evening!")
        } else if (hour >= 22 && hour < 4) {
            setgreeting(" Night!")
        }
    }

    const handleScroll = () => {
        let scrollT = window.scrollY
        let vh = window.innerHeight
        navTextColor(scrollT, vh)
        if (scrollT >= (vh / 1.4) || isOpen) {
            setmyName(1)

        } else {
            setmyName(0)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        getGreeting()
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <div>
            <nav id="nav-bar">
                <div>
                    <motion.span
                        initial={{ color: 'white' }}
                        animate={{ color: color }}
                        transition={{ ease: "easeOut", duration: .4, delay: 0.2 }}
                        className="greet">Good <span id="greeting">{greeting}</span></motion.span>
                    <motion.div
                        initial={{ opacity: 0, x: '100vw', color: 'white' }}
                        animate={{ opacity: myName, x: '0', color: color }}
                        transition={{ ease: "easeOut", duration: .4, delay: 0.2 }}
                        className="nav-name"
                    >NITHIN SAI</motion.div>
                </div>
                <div className={classToggle} onClick={() => toggle("")}>
                    <motion.div
                        initial={{ backgroundColor: 'white' }}
                        animate={{ backgroundColor: color }}
                        transition={{ ease: "easeIn", duration: .4 }}
                        className="bar1"></motion.div>
                    <div className="bar2"></div>
                    <motion.div
                        initial={{ backgroundColor: 'white' }}
                        animate={{ backgroundColor: color }}
                        transition={{ ease: "easeIn", duration: .4 }}
                        className="bar3"></motion.div>
                </div>
            </nav>
            <motion.div
                initial={{ y: '-150vw' }}
                animate={{ y: menuTog }}
                transition={{ ease: "easeOut", duration: .6, delay: 0 }}
                className="menu">
                <ParticlesNav />
                <motion.ul
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: .6, delay: 0 }}
                >
                    <motion.li
                        initial={list.initial}
                        animate={list.animate}
                        transition={{ duration: .6, delay: .2 }} >
                        <h1>
                            <a href="https://www.linkedin.com/in/nithin-sai" target="_blank" without="true" rel="noopener noreferrer" >
                                LINKED<span className="fa fa-linkedin c-icon"></span>
                            </a>
                        </h1>
                    </motion.li>
                    <motion.li
                        initial={list.initial}
                        animate={list.animate}
                        transition={{ duration: .6, delay: .3 }}>
                        <h1>
                            <a href="https://www.instagram.com/nithinsai_/?hl=en" target="_blank" without="true" rel="noopener noreferrer" >
                                INSTAGRAM<span className="fa fa-instagram c-icon"></span>
                            </a>
                        </h1>
                    </motion.li>
                    <motion.li
                        initial={list.initial}
                        animate={list.animate}
                        transition={{ duration: .6, delay: .4 }} >
                        <h1>
                            <a href="https://www.github.com/ninjaasmoke" target="_blank" without="true" rel="noopener noreferrer" >
                                GITHUB<span className="fa fa-github c-icon"></span>
                            </a>
                        </h1>
                    </motion.li>
                </motion.ul>
                <motion.ul
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: .6, delay: 0 }}
                    className="links"
                >
                    <motion.li
                        initial={rlist.initial}
                        animate={rlist.animate}
                        transition={{ duration: .6, delay: .4 }} >
                        <h1>
                            <NavLink to="/about" onClick={() => toggle()}>ABOUT</NavLink>
                        </h1>
                    </motion.li>
                    <motion.li
                        initial={rlist.initial}
                        animate={rlist.animate}
                        transition={{ duration: .6, delay: .3 }}>
                        <h1>
                            <a href="mailto:nithins674@gmail.com" target="_blank" without="true" rel="noopener noreferrer" >
                                EMAIL ME
                            </a>
                        </h1>
                    </motion.li>
                    {/* <motion.li
                        initial={rlist.initial}
                        animate={rlist.animate}
                        transition={{ duration: .6, delay: .2 }} >
                        <h1>
                            <a href="https://www.github.com/ninjaasmoke" target="_blank" without="true" rel="noopener noreferrer" >
                                GITHUB<span className="fa fa-github c-icon"></span>
                            </a>
                        </h1>
                    </motion.li> */}
                </motion.ul>
            </motion.div>
        </div >
    )
}
